import axios, { AxiosError } from 'axios';

export  function  apiClientMater() {
    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9596/masterAccessManagement',
        timeout: 1000,
        headers: {
            'Content-Type': 'application/json',
        }

    }) 
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            console.error("Erro na requisição:", error.message);
            return 401; // Rejeita corretamente
        }
    );
    return api
}



